import "./App.css";
import { Board } from "./Components/Board";


function App() {
  return (
    <>
    <div className="header">
      <h1>Tic Tac Toe</h1>
    </div>
    <Board/>
    </>
  )
}

export default App;
